import "core-js/stable";

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import moment from "moment";
import "moment/locale/ko";
import "moment/locale/ja";
import "moment/locale/zh-cn";
import "moment/locale/pt-br";

import { getLocalLngList, getLocalResource, getDefaultLanguage } from "../../modules/localization";

// 콘솔 언어 코드 → moment locale ID (moment는 zh/pt-BR 코드를 인식하지 못한다)
const MOMENT_LOCALE_BY_LANGUAGE = {
    en: "en",
    ko: "ko",
    ja: "ja",
    zh: "zh-cn",
    "pt-BR": "pt-br",
};

/**
 * 선택된 콘솔 언어에 맞춰 moment 전역 locale을 설정한다.
 * 날짜/시간 포맷(LT, LTS, MMMM, dddd 등)은 번역 리소스가 아닌 이 locale이 결정한다.
 * @param {string} language 콘솔 언어 코드 (en | ko | ja | zh | pt-BR)
 */
export function applyMomentLocale(language) {
    moment.locale(MOMENT_LOCALE_BY_LANGUAGE[language] ?? "en");
}

i18n.use(initReactI18next).init({
    resources: {},
    debug: false,

    fallbackLng: ["en", "ja", "ko", "zh", "pt-BR"],

    nsSeparator: "::",
    keySeparator: "::",

    react: {
        useSuspense: false,
        transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p", "span"],
    },

    interpolation: {
        escapeValue: false, // react already safes from xss
    },
});

// 언어가 바뀌면 moment locale도 함께 동기화한다.
i18n.on("languageChanged", applyMomentLocale);

export async function i18init() {
    let i18nLng = localStorage.getItem("i18nLng");

    // 코드에서 정의한 선택 가능 언어 목록을 항상 최신화 (신규 언어가 즉시 노출되도록)
    const { locales } = getLocalLngList(getDefaultLanguage());
    localStorage.setItem("i18nResources", JSON.stringify(locales));

    if (!i18nLng) {
        i18nLng = getDefaultLanguage();
    }

    const languages = getLocalResource(i18nLng);
    i18n.addResourceBundle(i18nLng, "translation", languages, true, true);

    // 선택한 언어를 실제 활성 언어로 설정한다.
    await i18n.changeLanguage(i18nLng);
    applyMomentLocale(i18nLng);
}

export default i18n;
